'use strict';

const eventHandlers = {
    changeQtyEventHandler() {
        const $this = $(this);
        const $qtyField = $this.siblings('.quantity-select');
        const currentQty = Number($qtyField.val());
        const minQty = Number($qtyField.data('minQty'));
        const maxQty = Number($qtyField.data('maxQty'));
        let newQty = $this.is('.quantity-select__cta--decrease') ? currentQty - 1 : currentQty + 1;

        newQty = Math.min(Math.max(minQty, newQty), maxQty);
        $qtyField.val(newQty);
    }
};

function attachEventHandlers() {
    $(document).on('click', '.quantity-select__cta', eventHandlers.changeQtyEventHandler);
}

module.exports = {
    api: {
        eventHandlers
    },
    init() {
        attachEventHandlers();
    }
};
